import _asyncToGenerator from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
var __jsx = React.createElement;
import _regeneratorRuntime from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";
import { Tabs } from '@material-ui/core';
import { useRouter } from 'next/router';
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { GradientTab } from 'components/common/material-ui/custom-components';
import { allNavPaths, navBarLinks } from 'config/routing';
import { useSiteConfig } from 'libs/common/hooks';
import { NavigationHeaderContainer, TabsContainer } from './NavigationHeader.style';

var NavigationHeader = function NavigationHeader() {
  var intl = useIntl();
  var router = useRouter();

  var _useSiteConfig = useSiteConfig(),
      site = _useSiteConfig.id;

  var currentTabsValue = useMemo(function () {
    return allNavPaths.find(function (navPath) {
      return router.pathname.startsWith("/[site]/".concat(navPath));
    });
  }, [router.pathname]);

  var onTabClickGenerator = function onTabClickGenerator(pageInfo) {
    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return router.push("/".concat(site, "/").concat(pageInfo.path));

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  };

  return __jsx(NavigationHeaderContainer, null, __jsx(TabsContainer, null, __jsx(Tabs, {
    value: currentTabsValue
  }, Object.values(navBarLinks).map(function (pageInfo) {
    return __jsx(GradientTab, {
      label: intl.formatMessage({
        id: pageInfo.label
      }),
      key: pageInfo.path,
      value: pageInfo.path,
      onClick: onTabClickGenerator(pageInfo)
    });
  }))));
};

export default NavigationHeader;